import ShippingConfigurationDetails  from  './ShippingConfigurationDetails'

export default ShippingConfigurationDetails